<script setup>
/*
 * En eller flere faerdige PC-opsaetninger.
 *
 * Buildkort er den samme komponent som paa spilsiderne. Prisen er dagens
 * sum af delene, ikke det tal builden blev gemt med.
 */
import Buildkort from '@/Components/PcBygger/Buildkort.vue';
import { computed } from 'vue';

const props = defineProps({
    data: { type: Object, required: true },
});

const maskiner = computed(() => props.data.maskiner || []);
</script>

<template>
    <p v-if="!maskiner.length" class="text-secondary small mb-0">
        Ingen offentlige opsætninger valgt.
    </p>

    <div v-else>
        <p v-if="data.begrundelse" class="mb-3">{{ data.begrundelse }}</p>
        <div class="pc-gitter">
            <Buildkort v-for="m in maskiner" :key="m.id" :build="m" />
        </div>
    </div>
</template>

<style scoped>
.pc-gitter { display: grid; gap: 1rem; grid-template-columns: repeat(auto-fill, minmax(19rem, 1fr)); }
</style>
